export const Consts = {
  INVALID_TOKEN_CODE: 412,
};
